import { ActionIcon, Box, Textarea } from "@mantine/core";
import type { GetInputPropsReturnType } from "@mantine/form/lib/types";
import { IconPlayerPlay } from "@tabler/icons-react";
import type { JSX, KeyboardEvent } from "react";
import classes from "./PromptInput.module.css";

interface Props extends GetInputPropsReturnType {
    placeholder: string;
    submitting: boolean;
    onSubmit: VoidFunction;
    size?: "xs" | "sm" | "md" | "lg" | "xl";
    onKeyDown?: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
}

function PromptInput({
    placeholder,
    submitting,
    onSubmit,
    size = "sm",
    onKeyDown,
    ...textareaProps
}: Props): JSX.Element {
    const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
        // Call consumer handler first
        onKeyDown?.(e);
        if (e.defaultPrevented) {
            return;
        }
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            onSubmit();
        }
    };

    return (
        <Box className={classes.box}>
            <Textarea
                placeholder={placeholder}
                autosize
                minRows={1}
                size={size}
                {...textareaProps}
                onKeyDown={handleKeyDown}
                styles={{ input: { paddingRight: 38 } }}
                disabled={submitting}
            />
            <ActionIcon className={classes.button} size={36} onClick={onSubmit} loading={submitting}>
                <IconPlayerPlay />
            </ActionIcon>
        </Box>
    );
}

export default PromptInput;
